import { cx } from "@/utils";
import Dialog from "@components/Dialog";

import DrawerContext from "./DrawerContext";

import styles from "./Drawer.module.css";

type DrawerProps = {
  open: boolean;
  className?: string;
  onClose?: () => void;
  children?: React.ReactNode;
};
/**
 * An animated drawer that slides in from the side of the page.
 */

const Drawer: React.FunctionComponent<DrawerProps> = ({
  open,
  onClose,
  className,
  children,
}) => {
  return (
    <DrawerContext.Provider value={{ onClose }}>
      <Dialog open={open} onClose={onClose}>
        <div className={cx(styles.root, className, { [styles.open]: open })}>
          {children}
        </div>
      </Dialog>
    </DrawerContext.Provider>
  );
};

export default Drawer;
